import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { AnimatedSection, NoiseTexture, GridPattern } from "../shared";

export default function FinalCTA() {
  return (
    <section className="py-16 md:py-20 px-6 relative overflow-hidden">
      <NoiseTexture />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0e0e14] to-[#0a0a0a]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_50%,_rgba(100,100,200,0.06),_transparent)]" />
      <GridPattern className="text-white opacity-[0.02]" />

      <div className="max-w-4xl mx-auto relative z-10 text-center">
        <AnimatedSection>
          <h2 className="font-space-grotesk text-5xl md:text-7xl lg:text-[5.5rem] font-bold tracking-[-0.03em] leading-[1.05] shimmer-text">
            Your agents are waiting.
          </h2>
          <p className="text-xl md:text-2xl text-white/50 mt-8 mb-14 max-w-2xl mx-auto leading-relaxed">
            Get $ATTS now and secure early access to the AGNT.Hub ecosystem before public launch.
          </p>
          <motion.a
            href="/dashboard"
            className="bg-white text-black px-10 py-5 rounded-full font-bold text-lg inline-flex items-center gap-3 relative overflow-hidden group no-underline"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
          >
            <span className="relative z-10 flex items-center gap-3">
              Get $ATTS Token
              <motion.span animate={{ x: [0, 6, 0] }} transition={{ duration: 1.5, repeat: Infinity }}>
                <ArrowRight size={22} />
              </motion.span>
            </span>
          </motion.a>

          <motion.div
            className="mt-14 flex justify-center gap-6 items-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            {["Secure", "Audited", "Non-Custodial"].map((item, i) => (
              <span key={item} className="flex items-center gap-6">
                {i > 0 && <div className="w-1 h-1 rounded-full bg-white/15" />}
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/40">{item}</span>
              </span>
            ))}
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
